import React, { Component } from 'react'

export class Workoder extends Component {
    render() {
        return (
<div className="box">
   <div className="box-body">
      <div className="box-header">
         <h3 className="box-title">Work Order</h3>
      </div>
      <form>
      <div className="col-md-12">        
            <div className="col-md-4">
               <div className="form-group">
                  <label>Tender No.</label> 
                  <select className="form-control select2" name="tenderid">
                     <option value="">Select Tender No</option>
                  </select>
                  <input className="form-control" type="text" readonly id="tenderid" />
               </div>
            </div>
            <div className="col-md-4">
               <div className="form-group">
                  <label>Work Order No.</label> 
                  <input className="form-control" type="text" name="workordno" />
               </div>
            </div>
            <div className="col-md-4">
               <div className="form-group">
                  <label>Work Order Date</label> 
                  <input className="form-control" placeholder="DD-MM-YYYY" type="text" name="workorddate" />
               </div>
            </div>
            </div>
            <div className="col-md-12">      
            <div className="col-md-4">
               <div className="form-group">
                  <label>Accepted Contract Price</label> 
                  <input className="form-control" type="text" name="tendamount" />
               </div>
            </div>
            <div className="col-md-4">
               <div className="form-group">
                  <label>Agreement Number</label> 
                  <input className="form-control" type="text" name="tenderagrementno" />
               </div>
            </div>
            <div className="col-md-4">
               <div className="form-group">
                  <label>Stipulated Date of Starting</label> 
                  <input className="form-control" type="text"  placeholder="DD-MM-YYYY" name="startdate" />
               </div>
            </div>
            </div>
            <div className="col-md-12">      
            <div className="col-md-4">
               <div className="form-group">
                  <label>Stipulated Date of Completion</label> 
                  <input className="form-control" type="text"  placeholder="DD-MM-YYYY" name="compdate" />
               </div>
            </div>
            <div className="col-md-4">
               <div className="form-group">
                  <label>Upload PDF</label> 
                  <input type="file" id="apppdf" name="apppdf" />
               </div>
            </div>
            <div className="col-md-4">
               <div className="form-group">
                  <label>Name of Contractor</label> 
                  <select className="form-control select2" id="agencyid" name="proposedagencyid">
                     <option value="">Select Name of Contractor</option>
                  </select>
               </div>
            </div>
            </div>
            <div className="col-md-12">      
            <div className="col-md-4" style={{padding:'2%'}}>	   
               <input type="submit" name="ini_submit" id="ini_submit" className="btn btn-info" value="Sace"  />
            </div>
            </div>
         </form>
      <div className="col-md-12 table-responsive">
         <table className="table table-bordered">
            <thead>
               <tr>
                  <th>Tender Notice No.</th>
                  <th>Work Order No</th>
                  <th>Work Order Date</th>
                  <th>Tender Agrement Number</th>
                  <th>Stipulated Date of Starting</th>
                  <th>Stipulated Date of Completion</th>
                  <th>Agencyname</th>
                  <th>Revised Date of Completion</th>
                  <th>Approval File</th>
                  <th>Edit</th>
                  <th>Delete</th>
               </tr>
            </thead>		
         </table>
      </div>
      </div>
      </div>
        )
    }
}

export default Workoder
